import { FETCH_TICKETS, FETCH_TICKET } from 'actions/tickets';

const INITIAL_STATE = {
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case FETCH_TICKET:
            return { ...state, ...action.payload };
        case FETCH_TICKETS:
            return action.payload;
        default:
            return state;
    }
}